export default __webpack_public_path__ + "static/media/login-dark.e7fe27f6.svg";